import { Tooltip } from "antd";
import styles from "./style.module.less";

export const ReviewingDot = () => {
    return (
        <div className={styles.reviewingDot}>
            <Tooltip placement="top" title="Reviewing">
                <i className="ri-checkbox-blank-circle-fill"></i>
            </Tooltip>
        </div>
    );
}